<template>
  <div class="info-wrapper">
    <img class="info-wrapper" :src="textData.img">
    <div ref="move" :class="moveClass">
      <div class="service_p">
        <h2>数字化员工</h2>
        <p class="fnt_24">基于AI及流程自动化技术的AI数字员工，解放人类员工，实现降本减负、提质增效。</p>
      </div>
      <div class="service_content">
        <div class="child">
          <div class="fnt_24" v-for="(item, index) in contentData" :key="index">
            <img src="../../../static/images/firstPage/jiantou.png">
            {{item.title}}
          </div>
<!--          <div class="fnt_24">-->
<!--            <img src="../../../static/images/firstPage/jiantou.png">-->
<!--            建立企业统一访问入口，提供一致化的用户体验服务于客户，方便于用户;-->
<!--          </div>-->
<!--          <div class="fnt_24">-->
<!--            <img src="../../../static/images/firstPage/jiantou.png">-->
<!--            长基于自主软件产品构建灵活可扩展的IT架构，持续升级与优化，更好完成解决项目存在的相关问题:-->
<!--          </div>-->
<!--          <div class="fnt_24">-->
<!--            <img src="../../../static/images/firstPage/jiantou.png">-->
<!--            集成企业各类业务系统、实现这些系统共同协同运行;-->
<!--          </div>-->
          <div>
            <el-button @click="routerTo(textData.link)">
              了解更多内容
              <i class="el-icon-caret-right el-icon--right"></i>
            </el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      moveClass: 'data-text move-before',
      textData: {},
      contentData: []
    }
  },
  methods: {
    routerTo (route) {
      this.$router.push({
        path: route,
        query: ''
      })
    }
  },
  mounted: function () {
    if (this.$boss) {
      this.textData = this.$boss.page141.g141[0]
      this.contentData = this.$boss.page142.g142.reverse()
    }
  }
}
</script>
<style scoped lang="less">
  .info-wrapper {
    width: 100%;
    height: 100%;
    /*background: url("../../../static/images/firstPage/digitalEmployees.png") no-repeat;*/
    background-size: 100% 100%;
  }
  @media screen and (max-width: 1900px) {
    .data-text {
      color: #FFFFFF;
      position: absolute;
      left: 200px;
      top: 12%;
      text-align: left;
      width: 100%;
      z-index: 999;
      transition: all 1.5s;
      -webkit-transition: all 1.5s;
    }
    .move-before{
      transform: translate(0,-50%);
      -webkit-transform: translate(0,-50%);
      -ms-transform: translate(0,-50%);
      opacity: 0;

    }

    .move-after{
      transform: translate(-100px,-50%);
      -webkit-transform: translate(-100px,-50%);
      -ms-transform: translate(-100px,-50%);
      opacity: 1;
    }
    .service_p h2, .service_p p {
      display: -webkit-box;
      overflow: hidden;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .service_p p {
      font-size: 22px;
      color: #dcd8f1;
    }
    .service_p h2 {
      font-size: 36px;
      margin-bottom: 15px;
      line-height: 60px;
      max-height: 120px;
    }
    .service_content{
      width: 60%;
      position: absolute;
      margin-top: 4%;
      .child{
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        div {
          padding: 10px 0;
          font-size: 22px;
          img {
            padding-right: 10px;
          }
        }
      }
      .el-button {
        margin-top: 50px;
        color: #fa6e1a;
        background-color: transparent;
        border: 1px solid #fa6e1a;
        font-size: 18px;
      }
    }
  }
  @media screen and (min-width: 1901px) {
    /*.info-wrapper {*/
    /*  width: 100%;*/
    /*  height: 100%;*/
    /*  background: url("../../../static/images/firstPage/digitalEmployees.png") no-repeat;*/
    /*  background-size: 100% 100%;*/
    /*}*/

    .data-text {
      color: #FFFFFF;
      position: absolute;
      left: 200px;
      top: 12%;
      text-align: left;
      width: 100%;
      z-index: 999;
      transition: all 1.5s;
      -webkit-transition: all 1.5s;
    }
    .move-before{
      transform: translate(0,-50%);
      -webkit-transform: translate(0,-50%);
      -ms-transform: translate(0,-50%);
      opacity: 0;

    }

    .move-after{
      transform: translate(-100px,-50%);
      -webkit-transform: translate(-100px,-50%);
      -ms-transform: translate(-100px,-50%);
      opacity: 1;
    }
    .service_p h2, .service_p p {
      display: -webkit-box;
      overflow: hidden;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .service_p p {
      font-size: 24px;
      color: #dee1f1;
    }
    .service_p h2 {
      font-size: 42px;
      margin-bottom: -15px;
      line-height: 60px;
      max-height: 120px;
    }
    .service_content{
      width: 60%;
      position: absolute;
      margin-top: 4%;
      .child{
        div {
          padding: 10px 0;
          font-size: 24px;
          img {
            padding-right: 10px;
          }
        }
      }
      .el-button {
        margin-top: 50px;
        color: #fa6e1a;
        background-color: transparent;
        border: 1px solid #fa6e1a;
        font-size: 18px;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/home/components/digitalEmployees.vue